import { Injectable } from '@angular/core';
import {
  DwAction,
  DwActionHandler,
  DwActionType,
  DwGridActionResult,
  DwMetaDataGridActionState
} from '@devwareapps/devware-cap';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AppMetaDataItemNames, DailyQuizEntity } from '../../../meta-data/app-meta-data.service';
import { AppPermissions } from '../../../meta-data/app-permissions.enum';
import { GamificationRepositoryService } from '../services/gamification-repository.service';

@DwAction({
  keyName: 'gamification-delete-daily-quiz',
  display: 'Delete',
  actionType: DwActionType.gridRowAction,
  parentItemName: AppMetaDataItemNames.DailyQuiz,
  isGlobal: false,
  defaultButtonConfig: {
    useParentDisplay: true,
    buttonTitle: 'Delete Daily Quiz',
    iconClass: 'dw-icon-delete-grid'
  },
  defaultSecurityConfig: {
    requireAuthentication: true,
    useEmulatedPermissions: true,
    permissionMeaning: AppPermissions.lMSSetupAdmin
  },
  defaultConfirmConfig: {
    showDialogConfig: true,
    showConfirmDialog: true,
    title: 'Delete Daily Quiz?',
    message: 'This deletes the Daily Quiz and all of its attempts and answers. This cannot be undone.'
  }
})
@Injectable()
export class DeleteDailyQuizActionService implements DwActionHandler {
  constructor(private readonly repository: GamificationRepositoryService) {}

  handleAction(actionState: DwMetaDataGridActionState<DailyQuizEntity>): Observable<DwGridActionResult> {
    const dailyQuizId = actionState.data && actionState.data.DailyQuizId;
    if (!dailyQuizId) {
      return of({ success: false, refreshData: false, message: 'The Daily Quiz could not be identified.' });
    }

    return this.repository.deleteDailyQuiz(dailyQuizId).pipe(
      map(result => ({
        success: true,
        refreshData: true,
        message: `Daily Quiz deleted with ${result.DeletedQuizResultCount} result attempt(s).`
      })),
      catchError(() => of({
        success: false,
        refreshData: false,
        message: 'The Daily Quiz could not be deleted.'
      }))
    );
  }
}
